import { Callout, HTMLTable, Spinner } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";

import i18n from "../../../../i18n";
import { authenticatedGetFetch } from "../../../../utils/AuthenticatedFetch";
import PieChart from "../../../Charts/PieChart";
import { mefCountry } from "../../../../utils/mef";

export default function Countries(props) {
  const [countries, setCountries] = useState();

  useEffect(() => {
    authenticatedGetFetch(
      "/ow/dc/perf/countries?" +
        new URLSearchParams({
          srv: props.srv,
          ...(props.from && { from: props.from }),
          ...(props.to && { to: props.to }),
        }),
      (countries) => setCountries(countries)
    );
  }, [props.srv, props.from, props.to]);

  return (
    <Callout icon="mobile-video" title={<Trans>plates origin</Trans>}>
      {countries ? (
        <div className="flexbox-left">
          <div>
            <HTMLTable compact={true} striped={true}>
              <thead>
                <tr>
                  <th>
                    <Trans>country</Trans>
                  </th>
                  <th>
                    <Trans>number of transaction</Trans>
                  </th>
                </tr>
              </thead>
              <tbody>
                {countries.map((l) => {
                  return (
                    <tr key={l.country}>
                      <td>{mefCountry(l.country)}</td>
                      <td>{l.count}</td>
                    </tr>
                  );
                })}
              </tbody>
            </HTMLTable>
          </div>
          <div>
            <PieChart
              labels={countries.map((c) => c.country)}
              data={countries.map((c) => c.count)}
              title={i18n.t("plates origin")}
            />
          </div>
        </div>
      ) : (
        <Spinner />
      )}
    </Callout>
  );
}
